// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBCS_UkVkTOOxqM4j_Ha7QS_N_t5jlAn6M",
  authDomain: "press-fee-tracker.web.app",
  projectId: "press-fee-tracker",
  storageBucket: "press-fee-tracker.firebasestorage.app",
  messagingSenderId: "1067389922991",
  appId: "1:1067389922991:web:61a8d0b5ed897ed334ee5a",
  measurementId: "G-ZP6565R1DV"
};

const app = initializeApp(firebaseConfig); // ✅ สร้างตัวแปร app
const db = getFirestore(app);
const auth = getAuth(app);

export { app, db, auth }; 